export enum ProgramDetailsTab {
  SETTINGS = 'settings',
  MODULES = 'modules',
}
